// extracted by mini-css-extract-plugin
export default {"wrapper-link":"Pageing_wrapper-link__GYzn+","icon":"Pageing_icon__R1Zmq","link":"Pageing_link__SCWtf"};